
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student-corner",
      function () {
        return require("private-next-pages/student-corner/index.js");
      }
    ]);
  